import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { AddButton } from 'components';
import { onModelFolderEnum, PermissionList, RolePermission, useModal, useSecondaryModal } from 'utils';
import { libraryTabEnums } from './constants';
import { AddGoal } from './addGoal';
import { AddFolder } from './addFolder';
import { domainActions } from 'store';
import { LibraryGoalDetails } from './goalDetails';

export const LibraryFilter = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const pushInfo = location?.state;
    const checkGoals = pushInfo?.tabType ? pushInfo?.tabType === libraryTabEnums.GOALS : libraryTabEnums.GOALS;
    const checkTargets = pushInfo?.tabType && pushInfo?.tabType === libraryTabEnums.TARGETS;
    const checkOptions = pushInfo?.tabType && pushInfo?.tabType === libraryTabEnums.OPTIONS;
    const { open } = useModal();
    const { openSecondary } = useSecondaryModal();

    useEffect(() => {
        dispatch(domainActions.getDomains());
    }, []);

    const renderParams = () => {
        const info = {
            ...pushInfo,
        };
        info.skip = info?.skip ? info?.skip : 0;
        info.limit = 50;

        delete info.page;
        delete info.activeTab;
        return info;
    };

    return (
        <div className="flex-align-center" style={{ width: '100%', justifyContent: 'flex-end', gap: 12 }}>
            {checkGoals ? (
                RolePermission([PermissionList.GOAL_CREATE?.code]) && (
                    <AddButton
                        text={'Add New Goal'}
                        handleClick={() =>
                            open(
                                <AddGoal
                                    requestParams={renderParams()}
                                    afterSuccess={(item) =>
                                        openSecondary(<LibraryGoalDetails goalId={item?.id} requestParams={renderParams()} />)
                                    }
                                />
                            )
                        }
                    />
                )
            ) : (
                <AddButton
                    text={'Add New Group'}
                    handleClick={() =>
                        open(
                            <AddFolder
                                onModel={checkTargets ? onModelFolderEnum.TARGET : onModelFolderEnum.OPTION}
                                requestParams={renderParams()}
                            />
                        )
                    }
                />
            )}
        </div>
    );
};
